import {
	Box,
	ButtonBase,
	LinearProgress,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { ChevronRight, Trophy } from "lucide-react";
import type { FC } from "react";
import { useFormatGoalAmount } from "web_myplann/Goals/Helpers/formatGoalAmount";
import {
	GOAL_CATEGORY_CONFIG,
	type Goal,
} from "web_myplann/Goals/Types/GoalTypes";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	goal: Goal;
	onClick: (goalId: string) => void;
};

export const CompletedGoalListItem: FC<Props> = ({ goal, onClick }) => {
	const theme = useTheme();
	const formatAmount = useFormatGoalAmount();
	const { t } = useResource();
	const CategoryIcon = GOAL_CATEGORY_CONFIG[goal.category].icon;

	return (
		<ButtonBase
			onClick={() => onClick(goal.id)}
			sx={{ width: "100%", textAlign: "left" }}
		>
			<Stack
				direction="row"
				alignItems="center"
				gap={1.2}
				px={1.6}
				py={1.2}
				width="100%"
			>
				<Box
					sx={{
						width: 40,
						height: 40,
						borderRadius: "50%",
						bgcolor: theme.palette.grey[100],
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexShrink: 0,
					}}
				>
					<CategoryIcon size={20} color={theme.palette.grey[400]} />
				</Box>

				<Stack flex={1} minWidth={0}>
					<Typography
						fontSize={14}
						fontWeight={500}
						color={theme.palette.grey[500]}
					>
						{goal.name}
					</Typography>
					<LinearProgress
						variant="determinate"
						value={100}
						sx={{
							height: 6,
							borderRadius: 3,
							bgcolor: theme.palette.grey[100],
							mb: 0.4,
							mt: 0.4,
							"& .MuiLinearProgress-bar": {
								borderRadius: 3,
								bgcolor: theme.palette.grey[300],
							},
						}}
					/>
					<Typography fontSize={12} color={theme.palette.grey[400]}>
						{formatAmount(goal.totalValue)}{" "}
						{t(Resources.Goals.Amount.currencySign)}
					</Typography>
				</Stack>

				<Trophy size={16} color={theme.palette.warning.main} />
				<ChevronRight size={16} color={theme.palette.grey[300]} />
			</Stack>
		</ButtonBase>
	);
};
